import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const go = useCallback((step: number) => {
    setDirection(step);
    setIndex(prev => (prev + step + testimonials.length) % testimonials.length);
  }, []);
  useEffect(() => {
    const timer = window.setInterval(() => go(1), 6000);
    return () => window.clearInterval(timer);
  }, [go]);
  const active = testimonials[index];
  return <section className="w-full bg-sage-mist py-16 sm:py-24" aria-labelledby="testimonios-title" data-id="element-132" data-mp="2s28cu7dnlgu4">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-133" data-mp="v9om7cysr3za">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-olive" data-id="element-134" data-mp="v72ftgnn6uin">
          Testimonios
        </span>
        <h2 id="testimonios-title" className="mt-3 font-display text-2xl font-extrabold tracking-tight text-black sm:text-3xl" data-id="element-135" data-mp="h5f0hpouu32s">
          Más de 1.200 emprendedores ya deciden con números, no con intuición.
        </h2>

        <div className="relative mt-10" data-id="element-136" data-mp="79lelfp8wx8c">
          <div className="relative min-h-[280px] sm:min-h-[240px]" data-id="element-137" data-mp="c6ljvoe9tvye">
            <AnimatePresence mode="wait" initial={false} data-id="element-138" data-mp="c8y282nxy8bz">
              <motion.figure key={active.name} initial={{
              opacity: 0,
              x: direction * 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction * -40
            }} transition={{
              duration: 0.35,
              ease: [0.4, 0, 0.2, 1]
            }} className="absolute inset-0 flex flex-col justify-center rounded-3xl border border-sage/70 bg-white p-8 text-left shadow-card sm:p-10" data-id="element-139" data-mp="zxhaii6zql42">
                <QuoteIcon className="h-8 w-8 text-sage" aria-hidden="true" data-id="element-140" data-mp="1nlqqv4lfqgnt" />
                <blockquote className="mt-4 font-display text-lg font-semibold leading-relaxed text-forest-deep sm:text-xl" data-id="element-141" data-mp="1xgxzxcbaibnh">
                  “{active.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3" data-id="element-142" data-mp="1ogj9jyjgy6d4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-forest font-display text-sm font-bold text-white" data-id="element-143" data-mp="1ji80hq0zzzvy">
                    {active.name.charAt(0)}
                  </span>
                  <span data-id="element-144" data-mp="19rwl97bv649r">
                    <span className="block font-display text-sm font-bold text-black" data-id="element-145" data-mp="19rdb4csggk6a">
                      {active.name}
                    </span>
                    <span className="block text-sm text-forest-deep/70" data-id="element-146" data-mp="14qz7r81styel">
                      {active.business}
                    </span>
                  </span>
                  <span className="ml-auto flex" aria-hidden="true" data-id="element-147" data-mp="vs3zlqf72e8n">
                    {Array.from({
                    length: 5
                  }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-olive text-olive" strokeWidth={1.5} data-id="element-148" data-mp="32gw6un1pqqg4" data-mpi={i} />)}
                  </span>
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>

          <div className="mt-6 flex items-center justify-center gap-4" data-id="element-149" data-mp="3gfnj03x0m21m">
            <button type="button" onClick={() => go(-1)} aria-label="Testimonio anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-forest bg-white text-forest transition-colors hover:bg-forest hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-forest" data-id="element-150" data-mp="2jqo4w89r261i">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-151" data-mp="20zwtz2a467l0" />
            </button>

            <div className="flex items-center gap-2" data-id="element-152" data-mp="251icb35f3e2l">
              {testimonials.map((testimonial, i) => <button key={testimonial.name} type="button" onClick={() => {
              setDirection(i > index ? 1 : -1);
              setIndex(i);
            }} aria-label={`Ver testimonio de ${testimonial.name}`} aria-current={i === index} className={`h-2.5 rounded-full transition-all duration-200 ${i === index ? 'w-7 bg-forest' : 'w-2.5 bg-sage'}`} data-id="element-153" data-mp="1lwn811jog1r2" data-mpi={i} />)}
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Testimonio siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-forest bg-white text-forest transition-colors hover:bg-forest hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-forest" data-id="element-154" data-mp="1zqnzda8aumhe">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-155" data-mp="fajb9g1rysew" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}